export const INLINE_NOTIFICATION_TYPES = {
    WARNING: 'warning' as const,
    ERROR: 'error' as const,
    SUCCESS: 'success' as const,
    INFO: 'info' as const
  };
  
  export type INLINE_NOTIFICATION_TYPES = typeof INLINE_NOTIFICATION_TYPES[keyof typeof INLINE_NOTIFICATION_TYPES];